import React from 'react';

import ConfirmingRequests from './tabs/ConfirmingRequests';

export interface IConfirmingTabConfig {
  value: string;
  label: string;
  Component: React.ComponentType;
}

export const CONFIRMING_TABS: IConfirmingTabConfig[] = [
  {
    value: 'requests',
    label: 'Confirming',
    Component: ConfirmingRequests,
  },
];

export const CONFIRMING_TAB_ITEMS = CONFIRMING_TABS.map(({ value, label }) => ({
  value,
  label,
}));

export const CONFIRMING_DEFAULT_TAB = CONFIRMING_TABS[0].value;

export const getTabComponent = (
  value: string,
): React.ComponentType | undefined =>
  CONFIRMING_TABS.find((tab) => tab.value === value)?.Component;
